import SEO from "@/components/shared/SEO";
import Hero from "@/features/home/sections/Hero";
import Welcome from "@/features/home/sections/Welcome";
import ChooseStay from "@/features/home/sections/ChooseStay";
import Dining from "@/features/home/sections/Dining";
// import Experiences from "@/features/home/sections/Experiences";
// import Amenities from "@/features/home/sections/Amenities";
// import Blog from "@/features/home/sections/Blog";
import Testimonials from "@/features/home/sections/Testimonials";
import FollowUs from "@/features/home/sections/FollowUs";

export default function HomePage() {
  return (
    <>
      <SEO
        title="Luxury Stays in Srinagar"
        description="Hotel Metropolis — a luxury stay in the heart of Srinagar, Kashmir. Rooms, dining, spa, and experiences on Dal Lake."
      />
      <Hero />
      <Welcome />
      <ChooseStay />
      <Dining />
      {/* <Experiences />
      <Amenities />
      <Blog /> */}
      <Testimonials />
      <FollowUs />
    </>
  );
}